import Logger from '../utils/Logger';

let { id: module_id } = module;
const logger = new Logger(module_id);

class CallQueue {
  constructor() {
    this.calls = {};
  }

  attach(path, wrappedCall) {
    logger.debug('getting callQueue for ', path);

    // if call doesn't exist, create it
    if (!this.calls[path]) {
      logger.debug('creating new call');
      // unwrap promise
      let call = wrappedCall();
      this.calls[path] = call;

      // attach deletion to promise
      call.then((data) => {
        delete this.calls[path];
        return data;
      });
      call.catch((err) => {
        delete this.calls[path];
        throw err;
      });
    } else {
      logger.debug('returning existing call');
    }

    return this.calls[path];
  }
}

export default CallQueue;
